import React from 'react';
import { getComputedCSSVariable } from '../../../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const NoteSVG: React.FC<Props> = ({
  color,
  style,
}) => {
  return (
    <span
      className="d-flex svg-wrapper"
      style={style}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
        xmlSpace="preserve"
      >
        <g>
          <path d="M68.5,22.7h-6.7v-0.1c0-1.5-1.3-2.8-2.8-2.8h-4.2c0-2.6-2.1-4.8-4.8-4.8s-4.8,2.1-4.8,4.8h-4.2c-1.5,0-2.8,1.3-2.8,2.8v0.1   h-6.7c-4.1,0-7.5,3.4-7.5,7.5v47.3c0,4.1,3.4,7.5,7.5,7.5h36.9c4.1,0,7.5-3.4,7.5-7.5V30.2C76,26.1,72.6,22.7,68.5,22.7z M73,77.5   c0,2.5-2,4.5-4.5,4.5H31.6c-2.5,0-4.5-2-4.5-4.5V30.2c0-2.5,2-4.5,4.5-4.5h6.7v0.1c0,1.5,1.3,2.8,2.8,2.8H59c1.5,0,2.8-1.3,2.8-2.8   v-0.1h6.7c2.5,0,4.5,2,4.5,4.5V77.5z" />
          <path d="M60.2,38.5H39.9c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6h20.3c0.9,0,1.6-0.7,1.6-1.6S61.1,38.5,60.2,38.5z" />
          <path d="M39.9,51.2h20.2c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6H39.9c-0.9,0-1.6,0.7-1.6,1.6S39,51.2,39.9,51.2z" />
          <path d="M39.9,60.5h20.2c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6H39.9c-0.9,0-1.6,0.7-1.6,1.6C38.3,59.8,39,60.5,39.9,60.5z" />
          <path d="M60.2,66.6H40c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6h20.2c0.9,0,1.6-0.7,1.6-1.6C61.9,67.4,61.1,66.6,60.2,66.6z" />
        </g>
      </svg>
    </span>
  );
};

NoteSVG.defaultProps = {
  color: getComputedCSSVariable('black'),
  style: {
    width: '15px',
    height: '15px',
  },
};

export default NoteSVG;
